import React, { memo, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import utils from '../../utils'
import { systemName } from '../../config'

const BiPage = props => {
  const { infoOptionStore } = props
  const { infoOptions } = infoOptionStore
  const [linkMisbi, setLinkMisbi] = useState(null)
  const optionKey = 'MISBI'
  useEffect(() => {
    ;(async () => {
      const link = await infoOptionStore.load(optionKey)
      if (link && utils.validURL(link)) {
        setLinkMisbi(link)
      }
    })()
  }, [infoOptions])
  return (
    <DashboardLayout>
      <Helmet>
        <title>Màn hình báo cáo</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'BI'}
        hiddenGoBack></PageTitle>
      <ContentBlockWrapper styles={{ height: '100%' }}>
        {systemName == 'VIMC' ? (
          <iframe
            title="TONG QUAN"
            width="100%"
            height="800"
            src={linkMisbi}
            frameBorder={0}
            allowFullScreen={true}></iframe>
        ) : (
          'Chưa có liên kết'
        )}
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

BiPage.propTypes = {}

export default memo(inject('infoOptionStore')(observer(BiPage)))
